import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '60vh', padding: '24px',
          textAlign: 'center', background: '#0a0a0a', color: '#e0e0e0'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>!</div>
          <h2 style={{ fontSize: '18px', marginBottom: '8px', color: '#f87171' }}>
            An error occurred
          </h2>
          <p style={{ fontSize: '14px', color: '#999', marginBottom: '24px', maxWidth: '300px' }}>
            Please refresh the page. If the problem persists, try clearing your browser cache.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 32px', background: '#ec4899', color: '#fff',
              border: 'none', borderRadius: '8px', fontSize: '14px',
              fontWeight: '600', cursor: 'pointer'
            }}
          >
            Refresh
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
